<mat-horizontal-stepper linear #stepper>
    <mat-step>
        <div>
            <img class="img" src="../../../assets/MmeRekik.PNG">
        </div>
        <div class="div-content">
            <div class="my-div">            
                <div class="display-flex">   
                    <div class="div-text">
                        <h1 class="h1-acceuile">
                            <b>
                                Questionnaire satisfaction client
                                <br>
                                استبيان رضا الحرفاء
                            </b>
                            
                        </h1>
                    </div>       
                </div>
                <div class="text-center">
                    <button  mat-raised-button matStepperNext class="btn-enter">
                        Entrée / دخول
                    </button>              
                </div>
            </div>
        </div>
    </mat-step>
    <mat-step>
        <div style="margin-top: 50px;" class="div-content">
            <div class="step">
                <div class="display-flex-2 step-row">
                    <div class="width-text-questionnaire"></div>
                    <div class="display-flex-2 width-radio-questionnaire text-center">
                        <div class="width-icon-questionnaire"><mat-icon class="color-green">sentiment_very_satisfied</mat-icon></div>
                        <div class="width-icon-questionnaire"><mat-icon class="color-orange">sentiment_satisfied</mat-icon></div>
                        <div class="width-icon-questionnaire"><mat-icon class="color-red">sentiment_very_dissatisfied</mat-icon></div>
                    </div>
                    <div dir="rtl" class="width-text-questionnaire"></div>
                </div>
                <div class="display-flex-2 step-row">
                    <div class="width-text-questionnaire">
                        <h1>Accueil</h1>
                    </div>
                    <div class="width-radio-questionnaire">
                        <mat-radio-group  [(ngModel)]="disponibiliter">
                            <div class="display-flex-2 text-center">
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                            </div>
                        </mat-radio-group>
                    </div>
                    <div dir="rtl" class="width-text-questionnaire">
                        <h1>الاستقبال</h1>
                    </div>
                </div>
                <div class="display-flex-2 step-row">
                    <div class="width-text-questionnaire"><h1>Service et  conseil</h1></div>
                    <div class="width-radio-questionnaire">
                        <mat-radio-group  [(ngModel)]="rapidite">
                            <div class="display-flex-2 text-center">
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                            </div>
                        </mat-radio-group>
                    </div>
                    <div dir="rtl" class="width-text-questionnaire"><h1>الخدمة والمشورة</h1></div>
                </div>
                <div class="display-flex-2 step-row">
                    <div class="width-text-questionnaire"><h1>Emballage</h1></div>
                    <div class="width-radio-questionnaire">
                        <mat-radio-group  [(ngModel)]="diversiteEmballage">
                            <div class="display-flex-2 text-center">
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                            </div>
                        </mat-radio-group>
                    </div>
                    <div dir="rtl" class="width-text-questionnaire"><h1>التعليب</h1></div>
                </div>
                <div class="display-flex-2 step-row">
                    <div class="width-text-questionnaire"><h1>Produit et Qualité</h1></div>
                    <div class="width-radio-questionnaire">
                        <mat-radio-group  [(ngModel)]="diversiteProduit">
                            <div class="display-flex-2 text-center">
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                            </div>
                        </mat-radio-group>
                    </div>
                    <div dir="rtl" class="width-text-questionnaire"><h1>المنتج والجودة</h1></div>
                </div>
               
                <div class="display-flex-3">
                    <button matStepperPrevious mat-icon-button ><mat-icon>arrow_back</mat-icon></button>
                    <button matStepperNext mat-icon-button ><mat-icon>arrow_forward</mat-icon></button>
                </div>  
            </div>
        </div>
    </mat-step>
    <mat-step>
        <div style="margin-top: 50px;" class="div-content">
            <div class="width-90">
                <div class="display-flex-2 step-row">
                    <div  class="width-20"><h1>Remarques</h1></div>
                    <div  class="flex-grow-3"></div>
                    <div dir="rtl"  class="width-20"><h1>ملاحظات</h1></div>
                </div>
                <div class="display-flex-4 step-row">
                    <div class="width-20">Remarques et suggestions </div>
                    <mat-form-field    class="flex-grow-3"   appearance="outline">
                        <input  matInput name="salleAtelier" [(ngModel)]="remarquesSuggestions">
                    </mat-form-field>
                    <div dir="rtl" class="width-20">ملاحظات و اقتراحات</div>
                </div>
                <div class="display-flex-4 step-row">
                    <div class="width-20">Nom et prénom </div>
                    <mat-form-field    class="flex-grow-3"   appearance="outline">
                        <input  matInput name="salleAtelier" [(ngModel)]="nomPrenom">
                    </mat-form-field>
                    <div dir="rtl" class="width-20">الاسم و اللقب</div>
                </div>
                <div class="display-flex-4 step-row">
                    <div class="width-20">N° de téléphone</div>
                    <mat-form-field    class="flex-grow-3"   appearance="outline">
                        <input  matInput name="salleAtelier" [(ngModel)]="nomPrenom">
                    </mat-form-field>
                    <div dir="rtl" class="width-20">رقم الهاتف</div>
                </div>
                <div class="display-flex-4 step-row">
                    <div class="width-20">E. mail</div>
                    <mat-form-field    class="flex-grow-3"   appearance="outline">
                        <input  matInput name="salleAtelier" [(ngModel)]="nomPrenom">
                    </mat-form-field>
                    <div dir="rtl" class="width-20">البريد الالكتروني</div>
                </div>
                <div class="display-flex-4 step-row">
                    <div class="width-20">Vous êtes notre client depuis</div>
                    <mat-form-field    class="flex-grow-3"   appearance="outline">
                        <input  matInput name="salleAtelier" [(ngModel)]="nomPrenom">
                    </mat-form-field>
                    <div dir="rtl" class="width-20">أنت حريفنا منذ</div>
                </div>
                <div class="display-flex-4 step-row">
                    <div class="width-20">Tranche d’âge</div>  
                    <div class="flex-grow-3">
                        <mat-radio-group  [(ngModel)]="rapiditeService">
                            <div class="display-flex-3 text-center">
                                <div ><mat-radio-button class="color-radio" value="0"> < 30 </mat-radio-button></div>
                                <div ><mat-radio-button class="color-radio" value="1">  30 => 50</mat-radio-button></div>
                                <div ><mat-radio-button class="color-radio" value="2"> > 50 </mat-radio-button></div>
                            </div>
                        </mat-radio-group>                            
                    </div>
    
                    <div dir="rtl" class="width-20">الفئة العمرية</div>
                </div>
                <div class="display-flex-3">
                    <button matStepperPrevious mat-icon-button ><mat-icon>arrow_back</mat-icon></button>
                    <button  style="font-size: 30px;width: 350px;height: 71px;"  mat-raised-button ><mat-icon style="margin-right: 33px; margin-top: -46px;">save</mat-icon>Enregistrer / حفض</button>
                </div>                
            </div>
        </div>
    </mat-step>
</mat-horizontal-stepper>


<!-- <div *ngIf="showQuestionnaire" style="height: 100%;width: 95%;">
    <mat-horizontal-stepper linear #stepper>
        <mat-step>
            <div class="div-content">
                <div class="step">
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire"><h1>Accueil</h1></div>
                        <div class="display-flex-2 width-radio-questionnaire text-center">
                            <div class="width-icon-questionnaire"><mat-icon class="color-green">sentiment_very_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-orange">sentiment_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-red">sentiment_very_dissatisfied</mat-icon></div>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire"><h1>الاستقبال</h1></div>
                    </div>

                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Disponibilité du personnel
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="disponibiliter">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            توفر العدد الكافي من العمال
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Apparence et tenue vestimentaire
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="Apparence">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            الهيئة و الهندام
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Amabilité
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="amabilite">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            اللطف و الحفاوة
                        </div>
                    </div>  
                    <div class="display-flex-3">
                        <div></div>
                        <button mat-icon-button matStepperNext><mat-icon>arrow_forward</mat-icon></button>
                    </div>                
                </div>
            </div>
        </mat-step>
        <mat-step>
            <div class="div-content">
                <div class="step">
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire"><h1>Service et  conseil</h1></div>
                        <div class="display-flex-2 width-radio-questionnaire text-center">
                            <div class="width-icon-questionnaire"><mat-icon class="color-green">sentiment_very_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-orange">sentiment_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-red">sentiment_very_dissatisfied</mat-icon></div>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire"><h1>الخدمة</h1></div>
                    </div>
                    
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Rapidité de service
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="rapidite">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            سرعة الخدمة
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Qualité de conseil
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="qualite">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            نجاعة النصائح
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Arrangement du paquet
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="arrangement">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            تنظيم العلبة
                        </div>
                    </div> 
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Respect des délais de livraison
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="respectDelaisLivraison">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            تنظيم العلبة
                        </div>
                    </div>  
                    <div class="display-flex-3">
                        <button mat-icon-button matStepperPrevious><mat-icon>arrow_back</mat-icon></button>
                        <button mat-icon-button matStepperNext><mat-icon>arrow_forward</mat-icon></button>
                    </div>                
                </div>
            </div>
        </mat-step>
        <mat-step>
            <div class="div-content">
                <div class="step">
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire"><h1>Emballage</h1></div>
                        <div class="display-flex-2 width-radio-questionnaire text-center">
                            <div class="width-icon-questionnaire"><mat-icon class="color-green">sentiment_very_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-orange">sentiment_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-red">sentiment_very_dissatisfied</mat-icon></div>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire"><h1>التعليب</h1></div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Diversité et disponibilité
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="diversiteEmballage">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            التنوع و التوفر
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Qualité
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="qualiteEmballage">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            الجودة
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Design
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="designEmballage">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            التصميم
                        </div>
                    </div>  
                    <div class="display-flex-3">
                        <button mat-icon-button matStepperPrevious><mat-icon>arrow_back</mat-icon></button>
                        
                        <button mat-icon-button matStepperNext><mat-icon>arrow_forward</mat-icon></button>
                    </div>                
                </div>
            </div>
        </mat-step>
        <mat-step>
            <div class="div-content">
                <div class="step">
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire"><h1>Produit et Qualité</h1></div>
                        <div class="display-flex-2 width-radio-questionnaire text-center">
                            <div class="width-icon-questionnaire"><mat-icon class="color-green">sentiment_very_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-orange">sentiment_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-red">sentiment_very_dissatisfied</mat-icon></div>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire"><h1>المنتوج</h1></div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Diversité et disponibilité
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="diversiteProduit">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            التنوع و التوفر
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Qualité
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="qualiteProduit">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            الجودة
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Nouveauté
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="nouveauteProduit">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            التجديد
                        </div>
                    </div>  
                    <div class="display-flex-3">
                        <button mat-icon-button matStepperPrevious><mat-icon>arrow_back</mat-icon></button>

                        <button mat-icon-button matStepperNext><mat-icon>arrow_forward</mat-icon></button>
                    </div>                
                </div>
            </div>
        </mat-step>
        <mat-step>
            <div class="div-content">
                <div class="step">
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire"><h1>Paiement</h1></div>
                        <div class="display-flex-2 width-radio-questionnaire text-center">
                            <div class="width-icon-questionnaire"><mat-icon class="color-green">sentiment_very_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-orange">sentiment_satisfied</mat-icon></div>
                            <div class="width-icon-questionnaire"><mat-icon class="color-red">sentiment_very_dissatisfied</mat-icon></div>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire"><h1>الاستخلاص</h1></div>
                    </div>
                    
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Disponibilité du caissier
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="disponibiliteCaissier">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            توفر القابض
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Amabilité du caissier
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="amabiliteCaissier">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            لطف و حفاوة القابض
                        </div>
                    </div>
                    <div class="display-flex-2 step-row">
                        <div class="width-text-questionnaire">
                            Rapidité du service
                        </div>
                        <div class="width-radio-questionnaire">
                            <mat-radio-group  [(ngModel)]="rapiditeService">
                                <div class="display-flex-2 text-center">
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-green" value="0"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-orange" value="1"></mat-radio-button></div>
                                    <div class="width-icon-questionnaire"><mat-radio-button class="color-red" value="2"></mat-radio-button></div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div dir="rtl" class="width-text-questionnaire">
                            سرعة الخدمة
                        </div>
                    </div>  
                    <div class="display-flex-3">
                        <button mat-icon-button matStepperPrevious><mat-icon>arrow_back</mat-icon></button>
                        <button mat-icon-button matStepperNext><mat-icon>arrow_forward</mat-icon></button>
                    </div>                
                </div>
            </div>
        </mat-step>
        
        <mat-step>
            <div class="div-content">
                <div class="width-90">
                    <div class="display-flex-2 step-row">
                        <div  class="width-20"><h1>Remarques</h1></div>
                        <div  class="flex-grow-3"></div>
                        <div dir="rtl"  class="width-20"><h1>ملاحظات</h1></div>
                    </div>
                    <div class="display-flex-4 step-row">
                        <div class="width-20">Remarques et suggestions </div>
                        <mat-form-field    class="flex-grow-3"   appearance="outline">
                            <input  matInput name="salleAtelier" [(ngModel)]="remarquesSuggestions">
                        </mat-form-field>
                        <div dir="rtl" class="width-20">ملاحظات و اقتراحات</div>
                    </div>
                    <div class="display-flex-4 step-row">
                        <div class="width-20">Nom et prénom </div>
                        <mat-form-field    class="flex-grow-3"   appearance="outline">
                            <input  matInput name="salleAtelier" [(ngModel)]="nomPrenom">
                        </mat-form-field>
                        <div dir="rtl" class="width-20">الاسم و اللقب</div>
                    </div>
                    <div class="display-flex-4 step-row">
                        <div class="width-20">N° de téléphone</div>
                        <mat-form-field    class="flex-grow-3"   appearance="outline">
                            <input  matInput name="salleAtelier" [(ngModel)]="nomPrenom">
                        </mat-form-field>
                        <div dir="rtl" class="width-20">رقم الهاتف</div>
                    </div>
                    <div class="display-flex-4 step-row">
                        <div class="width-20">E. mail</div>
                        <mat-form-field    class="flex-grow-3"   appearance="outline">
                            <input  matInput name="salleAtelier" [(ngModel)]="nomPrenom">
                        </mat-form-field>
                        <div dir="rtl" class="width-20">البريد الالكتروني</div>
                    </div>
                    <div class="display-flex-4 step-row">
                        <div class="width-20">Vous êtes notre client depuis</div>
                        <mat-form-field    class="flex-grow-3"   appearance="outline">
                            <input  matInput name="salleAtelier" [(ngModel)]="nomPrenom">
                        </mat-form-field>
                        <div dir="rtl" class="width-20">أنت حريفنا منذ</div>
                    </div>
                    <div class="display-flex-4 step-row">
                        <div class="width-20">Tranche d’âge</div>  
                        <div class="flex-grow-3">
                            <mat-radio-group  [(ngModel)]="rapiditeService">
                                <div class="display-flex-3 text-center">
                                    <div ><mat-radio-button class="color-radio" value="0"> < 30 </mat-radio-button></div>
                                    <div ><mat-radio-button class="color-radio" value="1">  30 => 50</mat-radio-button></div>
                                    <div ><mat-radio-button class="color-radio" value="2"> > 50 </mat-radio-button></div>
                                </div>
                            </mat-radio-group>                            
                        </div>

                        <div dir="rtl" class="width-20">الفئة العمرية</div>
                    </div>
                    <div class="display-flex-3">
                        <button mat-icon-button matStepperPrevious><mat-icon>arrow_back</mat-icon></button>
                        <button mat-icon-button ><mat-icon>save</mat-icon></button>
                    </div>                
                </div>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div> -->